<template>
    <v-container fill-height>
        <v-layout>
            <UserForm :userId="'userNew'"></UserForm>
        </v-layout>
    </v-container>
</template>

<script>
    import UserForm from '../components/detail/user/UserForm';

    export default {
        name: "User",
        components: {
            UserForm
        }
    };
</script>
